export const achievementData = {
    bio : "Till date, I have participated in many national-level technical events organised by top institutes such as IIT's and NIT's and have been the winner most of the time. I have also conducted and attended a few workshops and have also volunteered at many national-level events at college level. Throughout my journey, I have been learning and exploring different technologies in order to make myself more productive and, moreover, to enhance my technical and practical skills to contribute towards the betterment of our society. ",
    achievements : [
        {
            id : 8,
            title : 'Secured 2nd position in a collaborative project for cloning KFC.com using a MERN stack at Masai.',
            details : '',
            date : 'June, 2022',
            field : 'Web Development',
            image : ' '
        },
        {
            id : 1,
            title : 'Secured 1st rank in the final semester of Engineering by scoring 9.65 SGPA.',
            details : '',
            date : 'Mar, 2020',
            field : 'Mechanical Engineering',
            image : ' '
        },
        {
            id : 2,
            title : 'My project got selected in Top 100 projects of KPIT and E-Yantra Nationwide.',
            details : '',
            date : 'Dec, 2019',
            field : 'Mechanical Engineering',
            image : ''
        },
        {
            id : 3,
            title : 'I was runner up among 86 colleges in QUIZ competition held at KLE IT Hubli.',
            details : '',
            date : 'Sep, 2019',
            field : 'Mechanical Engineering',
            image : ''
        },
        {
            id : 4,
            title : 'Secured 2nd position in Best out of waste event among 219 colleges affiliated to VTU .',
            details : '',
            date : 'Mar, 2019',
            field : 'Mechanical Engineering',
            image : ''
        },
        {
            id : 5,
            title : ' Secured 1st position in Robo race and Path finder consecutively for 2 years.',
            details : '',
            date : '',
            field : 'Mechanical Engineering',
            image : ''
        },
        {
            id : 6,
            title : 'Secured 3rd position in on the spot Painting and Face Painting in the inter-college and intercollegiate competitions for 2 years .',
            details : '',
            date : '',
            field : 'Mechanical Engineering',
            image : ''
        },
        {
            id : 7,
            title : ' Won the inter-college football competition consecutively for 3 years.',
            details : '',
            date : '',
            field : '',
            image : ''
        }

    ]
}
